// extracted by mini-css-extract-plugin
module.exports = {"loading":"Uploading_loading__2tyDK","loadingPng":"Uploading_loadingPng__2o6gd","loadingTitle":"Uploading_loadingTitle__1863L","loadingStatus":"Uploading_loadingStatus__3F5MG"};